/**
 * Watchers for NewRelic data
 * @module services/newrelic/watchers
 */
import { getLocationPathname } from '../location'
import { SET_PAGE_READY } from '../pages/redux/actions'
import { SET_LOCATION_DATA } from '../location/redux/actions'
import { getAuthUid, getAuthUsername, getAuthRoles } from '../auth'
import { SET_AUTH_DATA } from '../auth/redux/actions'

/**
 * Get the NewRelic instance
 */
function getNewRelicInstance () {
  const { newrelic } = global
  return newrelic
}

/**
 * Get the global application data
 */
function getAppData () {
  const { __APP_DATA__ } = global
  return __APP_DATA__
}

export function addRelease ({ after }) {
  return after(SET_PAGE_READY, () => {
    const { app: { version } } = getAppData()
    const newrelic = getNewRelicInstance()
    newrelic.addRelease('admin-app', version)
  })
    .when(getNewRelicInstance)
}

export function setPageViewName ({ after }) {
  return after(SET_LOCATION_DATA, ({ state }) => {
    const { location } = state
    const pathname = getLocationPathname(location)
    const newrelic = getNewRelicInstance()
    newrelic.setPageViewName(pathname)
  })
    .when(getNewRelicInstance)
}

export function setCustomAttributes ({ after }) {
  return after(SET_AUTH_DATA, ({ state }) => {
    const { auth } = state
    const newrelic = getNewRelicInstance()
    const uid = getAuthUid(auth)
    const username = getAuthUsername(auth)
    let roles = getAuthRoles(auth)
    if (roles) {
      roles = JSON.stringify(roles.toJS())
    }
    if (!uid) {
      newrelic.setCustomAttribute('uid', '')
      newrelic.setCustomAttribute('username', '')
      newrelic.setCustomAttribute('roles', '')
      return
    }
    newrelic.setCustomAttribute('uid', uid)
    newrelic.setCustomAttribute('username', username)
    newrelic.setCustomAttribute('roles', roles)
  })
    .when(getNewRelicInstance)
}
